function cov_1iqilx9i5i() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/growth/novo/inputs/HelperText.tsx";
  var hash = "1ddbfed64e8bcbe9cfc2bd5ff6186a91916a6ce4";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/growth/novo/inputs/HelperText.tsx",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 46
        },
        end: {
          line: 14,
          column: 1
        }
      },
      "1": {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 13,
          column: 9
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 10,
            column: 46
          },
          end: {
            line: 10,
            column: 47
          }
        },
        loc: {
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 13,
            column: 9
          }
        },
        line: 11
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 11,
            column: 15
          },
          end: {
            line: 11,
            column: 49
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 11,
            column: 23
          },
          end: {
            line: 11,
            column: 33
          }
        }, {
          start: {
            line: 11,
            column: 36
          },
          end: {
            line: 11,
            column: 49
          }
        }],
        line: 11
      }
    },
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "1ddbfed64e8bcbe9cfc2bd5ff6186a91916a6ce4"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1iqilx9i5i = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1iqilx9i5i();
import React from 'react';
import { Text } from '@opendoor/bricks/core';
cov_1iqilx9i5i().s[0]++;
var HelperText = function HelperText(_ref) {
  var error = _ref.error,
    children = _ref.children;
  cov_1iqilx9i5i().f[0]++;
  cov_1iqilx9i5i().s[1]++;
  return /*#__PURE__*/React.createElement(Text, {
    color: error ? (cov_1iqilx9i5i().b[0][0]++, 'error500') : (cov_1iqilx9i5i().b[0][1]++, 'warmgrey800'),
    size: "100"
  }, children);
};
export default HelperText;
//# sourceMappingURL=HelperText.mjs.map